import React from 'react';
import classNames from 'classnames';
import { isEmpty } from 'lodash';
import { I18n, translate } from '@fiverr-private/i18n-react';
import { Tooltip, Icon } from '@fiverr-private/fit';
import { s_question_circle } from '@fiverr-private/icons';
import { grey_800 } from '@fiverr-private/sass/helpers';
import { selectRecipientInfo, useStaticContext } from '../../context/contexts/static';
import { PROFICIENCY_MAPPING } from './constants';

import classes from './style.module.scss';

const SpokenLanguages = () => {
    const context = useStaticContext();
    const { proficientLanguages } = selectRecipientInfo(context);

    const languagesWithLevels = proficientLanguages && Object.keys(proficientLanguages).map(
        (name) => ({
            name: translate(`languages.codes.${name}`),
            level: translate(`languages.proficiencies.level_${PROFICIENCY_MAPPING[proficientLanguages[name]]}`)
        }));

    if (isEmpty(languagesWithLevels)) {
        return null;
    }

    return (
        <div className={classNames(classes.sellerSpokenLanguages, 'co-grey-1000')}>
            <I18n k="send_message.languages.speaks_list"
                params={{ languages: languagesWithLevels.map((lang) => lang.name).join(', ') }}
                templates={{
                    'speak': (text) => (<span>{text}</span>),
                    'list': (text) => (<span className="text-semi-bold">{text}</span>)
                }}/>
            <Tooltip boxContentClassName={classes.tooltipContent}
                className={classes.infoIconTooltip}
                contentClassName="m-l-8"
                appendToBody={false}
                content={
                    <div data-testid="spoken-languages-tooltip">
                        <span className={classes.recipientSpeaksLabel}>
                            <I18n k="send_message.languages.recipient_speaks"/>
                        </span>
                        {languagesWithLevels.map(({ name, level }) => (
                            <div key={name + level}>{name} ({level})</div>
                        ))}
                    </div>
                }>
                <span className="inline-flex" data-testid="spoken-languages-icon">
                    <Icon size={12} color={grey_800}>
                        {s_question_circle}
                    </Icon>
                </span>
            </Tooltip>
        </div>
    );
};

export default SpokenLanguages;
